import { useEffect, useState } from 'react';
import { authTokenService } from '../services/authTokenService';
import { decodeToken } from '@/helpers/tokenHelpers';
import { AuthTokenType } from '@/types/sharedTypes';
import { SIGN_UP_STEP, SignUpStepType } from '@/const/shared';
import { SelfUserDetailsType } from '@/api/v1/users/getSelfUserDetailsApi';

export const getAdminOnboardingFlow = (user: SelfUserDetailsType) => {
  const signUpStep = user?.signup_step;

  return {
    isOnboardingFlow: signUpStep === SIGN_UP_STEP.ONBOARDING || signUpStep === SIGN_UP_STEP.TRIAL_MODE,
    signUpStep,
  };
};

export const useAdminOnboardingFlowFromAuthToken = () => {
  const [isOnboardingFlow, setIsOnboardingFlow] = useState(false);
  const [signUpStep, setSignUpStep] = useState<SignUpStepType | null>(null);

  useEffect(() => {
    const tokens = authTokenService.getTokens();

    if (!tokens) return;

    const { signup_step } = decodeToken<AuthTokenType>(tokens.access);

    setSignUpStep(signup_step);

    if (signup_step === SIGN_UP_STEP.ONBOARDING || signup_step === SIGN_UP_STEP.TRIAL_MODE) {
      setIsOnboardingFlow(true);
    } else {
      setIsOnboardingFlow(false);
    }
  }, []);

  return {
    isOnboardingFlow,
    signUpStep,
  };
};
